export default "__VITE_ASSET__e04bf8ee__"